<template>
  <ul class="product-usp-list">
    <template v-for="(item, index) of buildProductUspListContent">
      <li
        v-if="item.text"
        :key="`product-usp-list__item-${index}`"
        class="product-usp-list__item text-desktop-small text-mobile-small"
      >
        <img :src="item.icon">

        <span v-text="item.text" />
      </li>
    </template>
  </ul>
</template>

<script>

/**
 * Vue: product-usp-list (product-usp-list)
 * -----------------------------------------------------------------------------
 * List of USP's.
 *
 * @param {Object} productUspListContent - Content that contains USP links
 */
export default {
  name: 'ProductUspList',

  props: {
    productUspListContent: {
      type: Object,
      default: () => ({ items: [] }),
    },
  },

  data() {
    return {

    }
  },

  computed: {

    /**
     * Computes items in product usp list
     * @returns {Array}
     */
    buildProductUspListContent() {
      const content = JSON.parse(JSON.stringify(this.productUspListContent))

      return content.items
    },
  },
}
</script>

<style lang="scss">
@import './product-usp-list';
</style>
